// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4137":"35ce0a8f","6654":"35ce0a8f","6717":"1a7fdca2","8895":"35ce0a8f"}[chunkId] + ".chunk.css";
};